import logo_Light from "../assets/images/logo-light.png";
import footer_one_shape from "../assets/images/shape/footer-one-shape.png";

const Footer =()=>{
    return(
       <>
       {/* Footer */}
       <footer className="main-footer footer-style-one">
          <div className="outer-box">
            <div className="footer-left">
              <div className="logo logo-light">
                <a href="/">
                  <img src={logo_Light} alt="Logo" />
                </a>
              </div>
              <button className="back-top-btn mobile-nav-toggler">
                <svg
                  width={19}
                  height={19}
                  viewBox="0 0 19 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="1.5" cy="1.5" r="1.5" fill="white" />
                  <circle cx="1.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="1.5" cy="17.5" r="1.5" fill="white" />
                  <circle cx="9.5" cy="1.5" r="1.5" fill="white" />
                  <circle cx="9.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="9.5" cy="17.5" r="1.5" fill="white" />
                  <circle cx="17.5" cy="1.5" r="1.5" fill="white" />
                  <circle cx="17.5" cy="9.5" r="1.5" fill="white" />
                  <circle cx="17.5" cy="17.5" r="1.5" fill="white" />
                </svg>
              </button>
            </div>
            <div className="row g-0 w-100">
              <div className="col-xl-8 left-column order-2 order-xl-1">
                <div className="footer-top">
                  <div className="row g-4">
                    <div className="col-lg-4">
                      <div className="info-item">
                        <ul>
                          <li>
                            <i className="fa-sharp fa-solid fa-phone" />
                          </li>
                          <li>
                            <span>Call Us:</span>
                            <h5 className="title">+966 53 589 7085</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="info-item">
                        <ul>
                          <li>
                            <i className="fa-sharp fa-solid fa-envelope" />
                          </li>
                          <li>
                            <span>Email Us:</span>
                            <h5 className="title">info@paic-sa.com</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="info-item">
                        <ul>
                          <li>
                            <i className="fa-sharp fa-solid fa-location-dot" />
                          </li>
                          <li>
                            <span>Hours:</span>
                            <h5 className="title">Daily: 8 AM to 6 PM</h5>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="widgets-section">
                  <div className="row g-4">
                    <div className="col-lg-4 footer-column">
                      <div className="footer-widget links-widget">
                        <h4 className="widget-title">Services</h4>
                        <div className="widget-content">
                          <ul className="user-links">
                            <li>
                              <a href="/service-detail/geotechnical-investigation">GEO Technical Investigation</a>
                            </li>
                              <li>
                              <a href="/service-detail/third-party-inspection-services">Third Party Vendor Inspection </a>
                            </li>
                             <li>
                              <a href="/service-detail/inspection-and-training-division">HSEQ Training Consultancy </a>
                            </li>
                            <li>
                              <a href="/service-detail/calibration">Calibration Services </a>
                            </li>
                             <li>
                              <a href="/sub-services">Civil Testing</a>
                            </li>
                            <li>
                              <a href="/service-detail/non-destructive-testing-ndt">Non-Destructive Testing (NDT)</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 footer-column">
                      <div className="footer-widget links-widget">
                        <h4 className="widget-title">Pages</h4>
                        <div className="widget-content">
                          <ul className="user-links">
                            <li>
                              <a href="/">Home</a>
                            </li>
                            <li>
                              <a href="/services">Services</a>
                            </li>
                            <li>
                              <a href="/verification">Verification</a>
                            </li>
                            <li>
                              <a href="/team">Team</a>
                            </li>
                            <li>
                              <a href="/clients">Our Clients</a>
                            </li>
                            <li>
                              <a href="/our-projects">Our Projects</a>
                            </li>
                            <li>
                              <a href="/contact">Contact Us</a>
                            </li>
                            <li>
                              <a href="/about">About Us</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4 footer-column">
                      <div className="footer-widget links-widget">
                        <h4 className="widget-title">Signup Newsletter</h4>
                        <div className="input-feild">
                          <input type="text" placeholder="Email Address" />
                          <a className="btn-one-rounded" href="#0">
                            Sign up now{" "}
                            <i className="fa-regular fa-angle-right" />
                          </a>
                        </div>
                        <ul className="footer-nav">
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-facebook-f" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-solid fa-x" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-vimeo-v" />
                            </a>
                          </li>
                          <li>
                            <a href="#0">
                              <i className="fa-brands fa-pinterest-p" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="footer-bottom">
                  <p className="copyright-text">
                    © Copyright {new Date().getFullYear()}. All Right by <a href="/">Pak Arab Inspection LTD. CO</a>
                  </p>
                </div>
              </div>
              <div className="col-xl-4 right-column order-1 order-xl-2">
                <div className="inner-column">
                  <h3 className="title">Need Our Services?</h3>
                  <a className="circle-btn" href="/contact">
                    Contact Us <i className="fa-regular fa-arrow-up-right" />
                  </a>
                  <div className="mt-10">
                    <h5 className="time">08 : 00 AM - 06 : 00 PM</h5>
                    <h5 className="date">Sunday - Thursday</h5>
                  </div>
                </div>
                <div className="shape">
                  <img src={footer_one_shape} alt="Image" />
                </div>
              </div>
            </div>
          </div>
        </footer>
        {/* Footer area end here */}
       </>
    )
}

export default Footer;